import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CustomMRTTableColumnsWithTooltips from 'src/components/form/theme-elements/CustomMRTTableColumnWithTooltip';
import MRTVoucherColumnDefinitions from './MRTVoucherColumnDefinitions';
import { MaterialReactTable } from 'material-react-table';
import { Box } from '@mui/material';
import EmptyStateValidation from 'src/components/common/EmptyStateValidation';
import { useNavigate } from 'react-router';
import { useMsal } from '@azure/msal-react';
import ElementReferenceList from './element-reference-list/ElementReferenceList';

const ViewClientVoucherInformation = () => {
    const { clientVoucherDetailsList, reservationOverview } = useSelector((state) => state.reservationsSummaryReducer);
    const { instance, accounts } = useMsal();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const columnDefs = useMemo(() => MRTVoucherColumnDefinitions(dispatch, navigate, instance, accounts, reservationOverview.AgentId), [dispatch, navigate, instance, accounts, reservationOverview.AgentId]);

    const columnsWithTooltips = CustomMRTTableColumnsWithTooltips(columnDefs);

    return (
        <Box p={5}>
            <MaterialReactTable
                columns={columnsWithTooltips}
                data={clientVoucherDetailsList || []}
                enableSorting
                enablePagination
                enableFullScreenToggle={false}
                enableExpanding
                renderDetailPanel={({ row }) => {
                    const items = row.original.Items || [];
                    return (
                        <ElementReferenceList dispatch={dispatch} navigate={navigate} items={items} reservationDetails={row.original}/>
                    );
                }}
                renderEmptyRowsFallback={() => (
                    <EmptyStateValidation message="No vouchers found" />
                )}
                initialState={{
                    sorting: [
                        {
                            id: 'VoucherNumber',
                            desc: true,
                        },
                    ],
                }}
                muiDetailPanelProps={{
                    sx: {
                        backgroundColor: "#f2f6fdff",
                    },
                }}
            />
        </Box>
    );
};

export default ViewClientVoucherInformation;